import React, { useState, createContext } from "react";

const globalContext = createContext();

const GlobalProvider = ({ children }) => {
  const [title, setTitle] = useState("");
  const [loader, setLoader] = useState(true);

  return (
    <globalContext.Provider value={{ title, setTitle, loader, setLoader }}>
      {children}
    </globalContext.Provider>
  );
};

export { GlobalProvider, globalContext };
